import * as React from "react"
import {Box} from "@mui/material";

import {dsColorNew} from "@palette";


// A small mark after a menu entry's title ("NEW", CU-869fmjzrg decision 13). It never replaces the title: it is extra
// text, read by screen readers after the name. Whether it shows is decided by `menu.js` (`menuBadge`), not here.
export default function NavBadge({ label }) {
    return <Box component="span" sx={{
        ml: 0.75, px: 0.75, height: 18, lineHeight: '18px', borderRadius: '999px', flexShrink: 0,
        fontSize: 10, fontWeight: 700, letterSpacing: 0.4, color: dsColorNew.appBlue, backgroundColor: dsColorNew.pillActiveBg,
    }}>{label}</Box>
}
